const PATRIOT_INPUT_FIELDS: Record<string, string> = {
  patriotServer: "patriot_server",
  patriotClientNo: "patriot_client_no",
  patriotUsername: "patriot_username",
  patriotPassword: "patriot_password",
  patriotZoneNumber: "patriot_zone_number",
  patriotTypeNumber: "patriot_type_number",
  patriotSendVideo: "patriot_send_video",
  drawIgnoreZones: "draw_ignore_zones",
};

const BOOLEAN_INPUTS = new Set(["patriotSendVideo", "drawIgnoreZones"]);

/**
 * Applies a partial Patriot alert to the stored bulk post object
 * (localStorage) and to one camera (objectId) or every camera.
 */
export const applyPatriotAlertPatch = (
  setCamerasObject: any,
  camerasObject: any,
  patch: Record<string, unknown>,
  objectId: number | null
) => {
  // Update localStorage first so AutoAddTable doesn't overwrite our changes
  const patriotAlertPostObject = JSON.parse(
    localStorage.patriotAlertPostObject || "{}"
  );
  Object.assign(patriotAlertPostObject, patch);
  localStorage.setItem(
    "patriotAlertPostObject",
    JSON.stringify(patriotAlertPostObject)
  );

  // Create a deep copy of the camerasObject to ensure React detects the change
  const newCamerasObject = { ...camerasObject };

  for (const key in camerasObject) {
    newCamerasObject[key] = {
      ...camerasObject[key],
      patriot: {
        ...camerasObject[key].patriot,
      },
    };
  }

  if (objectId) {
    // Handle single object update
    Object.assign(newCamerasObject[objectId].patriot, patch);

    setCamerasObject((previousState: any) => {
      return { ...previousState, [objectId]: newCamerasObject[objectId] };
    });
  } else {
    // Handle all objects update
    for (const key in newCamerasObject) {
      Object.assign(newCamerasObject[key].patriot, patch);
    }

    setCamerasObject(newCamerasObject);
  }
};

export const handlePatriotInput = (
  setCamerasObject: any,
  camerasObject: any,
  inputString: string,
  inputBoolean: boolean,
  objectId: number | null,
  inputNameString: string
) => {
  const field = PATRIOT_INPUT_FIELDS[inputNameString];
  const patch: Record<string, unknown> = field
    ? {
        [field]: BOOLEAN_INPUTS.has(inputNameString)
          ? inputBoolean
          : inputString,
      }
    : {};
  applyPatriotAlertPatch(setCamerasObject, camerasObject, patch, objectId);
};
